import React from 'react';
import classNames from 'classnames/bind';
import { TextBase } from "../internal/TextBase";
import MarketLink from '../MarketLink';
import styles from './FooterBottom.css';
var cx = classNames.bind(styles);

var FooterBottom = function FooterBottom(props) {
  var socialsList = props.socialsList,
      appstoreLink = props.appstoreLink,
      googleplayLink = props.googleplayLink,
      _props$language = props.language,
      language = _props$language === void 0 ? 'en' : _props$language;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('FooterBottom')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('Wrapper')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('Items')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('SocialLinks')
  }, socialsList), (appstoreLink || googleplayLink) && /*#__PURE__*/React.createElement("div", {
    className: cx('MarketLinks')
  }, appstoreLink && /*#__PURE__*/React.createElement("div", {
    className: cx('MarketLinksItem')
  }, /*#__PURE__*/React.createElement(MarketLink, {
    lang: language,
    href: appstoreLink,
    type: "appstore"
  })), googleplayLink && /*#__PURE__*/React.createElement("div", {
    className: cx('MarketLinksItem')
  }, /*#__PURE__*/React.createElement(MarketLink, {
    lang: language,
    href: googleplayLink,
    type: "googleplay"
  }))), /*#__PURE__*/React.createElement("div", {
    className: cx('copyright')
  }, /*#__PURE__*/React.createElement(TextBase, {
    size: "s"
  }, "\xA9 ", new Date().getFullYear(), ". S7 Airlines")))));
};

export default FooterBottom;